import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'telegramBannerShown';

export default function TelegramBanner() {
    const [isVisible, setIsVisible] = useState(() => {
        return localStorage.getItem(STORAGE_KEY) !== 'true';
    });

    useEffect(() => {
        if (!isVisible) return;

        // Mark banner as shown immediately
        localStorage.setItem(STORAGE_KEY, 'true');

        // Automatically hide after 8 seconds
        const timer = setTimeout(() => {
            setIsVisible(false);
        }, 8000);

        return () => clearTimeout(timer);
    }, [isVisible]);

    const handleClose = () => {
        localStorage.setItem(STORAGE_KEY, 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="telegram-banner">
            <div className="telegram-banner-content">
                <button
                    type="button"
                    className="telegram-banner-close"
                    aria-label="Close Telegram banner"
                    onClick={handleClose}
                >
                    &times;
                </button>

                <a
                    href="https://t.me/fghofficialactivitygroup"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="/images/promotions/FGH-TELEGRAM-COMMUNITY.webp"
                        alt="Join our Telegram Community"
                    />
                </a>
            </div>
        </div>
    );
}
